module.exports = __webpack_public_path__ + "museosans100-webfont.691e8ab788214f17694c.woff2";


//////////////////
// WEBPACK FOOTER
// D:/api-fronted/css/fonts/museosans100-webfont.woff2
// module id = ../../../../../css/fonts/museosans100-webfont.woff2
// module chunks = styles